/* eslint-disable arrow-parens */
import studentsApi from '@/api/students';

// initial state
const state = {
  studentsOnPage: [],
  addStudentModalOpen: false,
  updateStudentModalOpen: false,
  selectedStudent: null,
  importStudentsModalOpen: false,
  paging: {
    page: 1,
    pageSize: 20,
  },
};

// getters
const getters = {
  students: (currentState) => currentState.studentsOnPage,
  paging: (currentState) => currentState.paging,
  addStudentModalOpen: (currentState) => currentState.addStudentModalOpen,
  updateStudentModalOpen: (currentState) => currentState.updateStudentModalOpen,
  selectedStudent: (currentState) => currentState.selectedStudent,
  importStudentsModalOpen: (currentState) =>
    currentState.importStudentsModalOpen,
};

// actions
const actions = {
  showAddStudentModal({ commit }) {
    commit('setAddStudentModalOpen', true);
  },
  hideAddStudentModal({ commit }) {
    commit('setAddStudentModalOpen', false);
  },
  showUpdateStudentModal({ commit }, student) {
    commit('setUpdateStudentModalOpen', {
      isOpen: true,
      selectedStudent: student,
    });
  },
  hideUpdateStudentModal({ commit }) {
    commit('setUpdateStudentModalOpen', {
      isOpen: false,
      selectedStudent: null,
    });
  },
  showImportStudentsModal({ commit }) {
    commit('setImportStudentModalOpen', true);
  },
  hideImportStudentsModal({ commit }) {
    commit('setImportStudentModalOpen', false);
  },
  getStudents({ dispatch, commit }, paging) {
    dispatch('showLoader');
    studentsApi.getStudents(paging).then((response) => {
      commit('setStudents', {
        students: response.data.data,
        paging: { page: response.data.page, pageSize: response.data.pageSize },
      });
      dispatch('hideLoader');
    });
  },
  createStudent({ dispatch, state: currentState }, student) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      studentsApi.createStudent(student).then(
        (response) => {
          dispatch('getStudents', currentState.paging);
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  updateStudent({ dispatch, state: currentState }, student) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      studentsApi.updateStudent(student).then(
        (response) => {
          dispatch('getStudents', currentState.paging);
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
};

// mutations
const mutations = {
  setStudents(currentState, { students, paging }) {
    currentState.studentsOnPage = students;
    currentState.paging = paging;
  },
  setAddStudentModalOpen(currentState, isOpen) {
    currentState.addStudentModalOpen = isOpen;
  },
  setUpdateStudentModalOpen(currentState, data) {
    currentState.updateStudentModalOpen = data.isOpen;
    currentState.selectedStudent = data.selectedStudent;
  },
  setImportStudentModalOpen(currentState, isOpen) {
    currentState.importStudentsModalOpen = isOpen;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/students.js